
import { Client } from './clientTypes';

export const retailClients: Client[] = [
  { 
    id: 4, 
    name: "POPS", 
    logoPath: "/lovable-uploads/01fe3092-9672-4b15-91c6-10423f4a00e5.png",
    altText: "Logo de POPS"
  },
  { 
    id: 5, 
    name: "PriceSmart", 
    logoPath: "/lovable-uploads/2334f89d-b258-449f-9e8e-cc8773b63d1b.png",
    altText: "Logo de PriceSmart"
  },
  { 
    id: 8, 
    name: "Aliss", 
    logoPath: "/lovable-uploads/9a1c2b2f-4e7c-4a56-b144-4efacd43772c.png",
    altText: "Logo de Aliss"
  },
  { 
    id: 13, 
    name: "Capris", 
    logoPath: "/lovable-uploads/a1489d77-9e2f-4284-b460-90e8dbd1ca4d.png",
    altText: "Logo de Capris"
  },
  { 
    id: 16, 
    name: "Dole", 
    logoPath: "/lovable-uploads/82bf5edf-6a5f-421b-8a99-c71da0173e2d.png",
    altText: "Logo de Dole"
  },
  { 
    id: 18, 
    name: "FIFCO", 
    logoPath: "/lovable-uploads/0fc276fe-a3f7-4354-a8d8-e77001a99652.png",
    altText: "Logo de FIFCO"
  },
  { 
    id: 26, 
    name: "La Artística Ashley", 
    logoPath: "/lovable-uploads/41a58016-35ff-42a7-81b4-468979a7472e.png",
    altText: "Logo de La Artística Ashley"
  },
  { 
    id: 27, 
    name: "Mabe", 
    logoPath: "/lovable-uploads/4a67f70a-df19-472b-a14f-ba0de3a43baf.png",
    altText: "Logo de Mabe" 
  },
  { 
    id: 37, 
    name: "Walmart", 
    logoPath: "/lovable-uploads/d4d49426-1ea9-4823-a057-23fe33de59a5.png",
    altText: "Logo de Walmart" 
  },
];
